var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _vm.type === 0
                ? _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: this.$t("CargoMsg.Cargo_RouteMarking")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { no: "routeMarking" },
                            model: {
                              value: _vm.from.routeMarking,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "routeMarking", $$v)
                              },
                              expression: "from.routeMarking"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === 1
                ? _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_FlightNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: { no: "voyageFlight" },
                            model: {
                              value: _vm.from.voyageFlight,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "voyageFlight", $$v)
                              },
                              expression: "from.voyageFlight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_FlightDate") }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "etd",
                            staticStyle: { flex: "1", width: "250px" },
                            attrs: {
                              no: "etd",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm",
                              clearable: ""
                            },
                            model: {
                              value: _vm.from.etd,
                              callback: function($$v) {
                                _vm.$set(_vm.from, "etd", $$v)
                              },
                              expression: "from.etd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_FreightUnitPrice")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { display: "flex", width: "250px" }
                            },
                            [
                              _c("auto-number-input", {
                                staticStyle: { width: "110px" },
                                attrs: {
                                  no: "freightAmount",
                                  precision: 0,
                                  min: 0
                                },
                                model: {
                                  value: _vm.from.freightAmount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.from, "freightAmount", $$v)
                                  },
                                  expression: "from.freightAmount"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: { no: "freightType" },
                                  model: {
                                    value: _vm.from.freightType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.from, "freightType", $$v)
                                    },
                                    expression: "from.freightType"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_UnitPrice"),
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_TotalPrice"
                                      ),
                                      value: 1
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  filterable: "",
                                  clearable: false,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  "default-value": _vm.from.freightCurrency
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.from.freightCurrency =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c("el-button", { on: { click: _vm.closeHandler } }, [
                    _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }